import { render } from "./TokensList.vue?vue&type=template&id=6fb37d1e"
import script from "./TokensList.vue?vue&type=script&lang=js"
export * from "./TokensList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__